"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionTypeSchema = exports.ComponentFunctionType = void 0;
const zod_1 = require("zod");
var ComponentFunctionType;
(function (ComponentFunctionType) {
    ComponentFunctionType["Bus"] = "bus";
    ComponentFunctionType["Custom"] = "custom";
})(ComponentFunctionType || (exports.ComponentFunctionType = ComponentFunctionType = {}));
exports.ComponentFunctionTypeSchema = zod_1.z.nativeEnum(ComponentFunctionType);
//# sourceMappingURL=ComponentFunctionType.js.map